"use strict";

var ExtensionService = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/service',
});
var ExtensionServices = Backbone.Collection.extend({
    model: ExtensionService,
    url: Core.contextRoot + '/service',
    comparator: function(model) {
        var title = i18next.t('extensionServiceLong_' + model.get('name'));
        if (!title || title.indexOf('extensionServiceLong') == 0) title = model.get('name');
        return title;
    },
});
var ExtensionServiceAccount = Backbone.Model.extend({});
var ExtensionServiceAccounts = Backbone.Collection.extend({
    model: ExtensionServiceAccount,
    url: Core.contextRoot + '/user/me/serviceaccount'
})
